var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',_vm._b({attrs:{"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ isActive, href, navigate }){return [_c('li',{class:isActive && 'is-active'},[_c('a',{attrs:{"href":href},on:{"click":navigate}},[_vm._t("default")],2)])]}}],null,true)},'router-link',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }